<template>
  <Control class="cx_timepicker" :title="title" :isEdit="isEdit && enabled" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"  :enabled="enabled"  :tooltip="tooltip"  :key="title">
    <template slot="read">{{ value | datetime('HH:mm') }}</template>
    <template slot="edit"><timepicker v-model="internalValue" hide-clear-button></timepicker>
    </template>
  </Control>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Moment from 'moment';
import resize from 'vue-resize-directive';

@Component({
  directives: {
    resize,
  },
})
export default class TimePicker extends Vue implements Components.IControl {
  @Prop({ default: '' }) public title?: string;
  @Prop({ default: null }) public value?: Date;
//   @Prop({ default: false }) public required: boolean;
//   @Prop({ default: false }) public deletable: boolean;

  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: null }) public nullValue: Date;
  @Prop({ default: "2000/1/1" }) public baseDate: string;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: true }) public isDirectEditEnabled: boolean;  
  @Prop() public tooltip: string;

  public isEdit: boolean = true;
  public validator: Components.ControlValidator;


  created() {
    this.validator = new Components.ControlValidator(this, 'tooltip', this.internalValidate);
    if (this.editor != null) this.editor.addControl(this);
  }
  destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }

  public mounted() {

    // if (this.$refs.target){
    //   const temp = (this.$refs.target as Vue).$children[0] as Vue;
    //   temp.$on('showCalendar', this.onOpening);
    //   console.log('hooked calendar resizer');
    // } else {
    //   console.log('failed to hook calendar resizer');
    // }
  }
  public internalValidate(): string {
    // if (this.required && this.internalValue == '') {
    //   return '必須項目です。';
    // }
    return '';
  }

  public get internalValue(): string {
    // 現地日付で文字列に変換する
    if (this.value == this.nullValue) return '00:00';

    const temp = Moment(this.value).format('HH:mm');
    return temp;
  }

  public set internalValue(value: string) {
    // ロケールでDate型に変換する(0:00 GMT+0900)
    const temp = value == null ? this.nullValue : Moment(String.format("{0} {1}",this.baseDate, value)).toDate();
    this.$emit('update:value', temp);
    this.$emit('changed');
    this.validator.update();
  }



//   public onOpening() {
//     //表示位置を右寄せで調整する〜下にスペースがない場合は上に表示したい。
//     const input = ((this.$refs.target as Vue).$el.children[0].children[0] as HTMLElement);
//     var popupQuery = 'div.vdp-datepicker__calendar';
//     const target = this.$refs.target as Vue;
//     var popupElements = target.$el.querySelectorAll(popupQuery);
//     popupElements.forEach(element => {
//       if (window.innerHeight > input.getBoundingClientRect().bottom + 223)
//         (element as HTMLElement).style.transform = 'translate(' + (input.clientWidth - 238) + 'px,1px)';
//       else
//         (element as HTMLElement).style.transform = 'translate(' + (input.clientWidth - 238) + 'px,'+ (-input.clientHeight - 223) +'px)';
//     });
//   }
}
</script>
<style lang="scss">
    .cx_timepicker{
        .vue__time-picker{
            .dropdown {
                left: unset;
                top:unset;
                position:fixed;
            }

            input.display-time {
                height: 22px;
                padding: 1px 5px;
                font-size: 13px;
                border-radius: 0.2rem;
                outline: none;
                -webkit-box-shadow: none;
                box-shadow: none;
                width:141px;
            }
        }
    }
</style>